import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRadio = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 20 20",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 10,
			cy: 10,
			r: 7.5,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", { d: "M14.1667 10.0001C14.1667 12.3013 12.3012 14.1667 10 14.1667C7.69883 14.1667 5.83335 12.3013 5.83335 10.0001C5.83335 7.69889 7.69883 5.83342 10 5.83342C12.3012 5.83342 14.1667 7.69889 14.1667 10.0001Z" }),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M1.66669 10.0001C1.66669 5.40008 5.40002 1.66675 10 1.66675C14.6 1.66675 18.3334 5.40008 18.3334 10.0001C18.3334 14.6001 14.6 18.3334 10 18.3334C5.40002 18.3334 1.66669 14.6001 1.66669 10.0001ZM3.33335 10.0001C3.33335 13.6834 6.31669 16.6667 10 16.6667C13.6834 16.6667 16.6667 13.6834 16.6667 10.0001C16.6667 6.31675 13.6834 3.33341 10 3.33341C6.31669 3.33341 3.33335 6.31675 3.33335 10.0001Z"
		})
	] })
});
export default SvgRadio;
